module.exports = __webpack_public_path__ + "img/dance-test-icon6.b6bdec58.png";